import { Component, OnInit, Input,  ViewChild, ViewContainerRef, ComponentFactoryResolver, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomAdapter } from '@angular/platform-browser/src/dom/dom_adapter';

@Component({
  selector: 'app-popup-dialog',
  templateUrl: './popup-dialog.component.html'
})
export class PopupDialogComponent implements OnInit {

  title = "Não informado";
  icon = "Não informado";

  useConfirm = false;

  cancelTitle = "Cancelar";

  @ViewChild("formulario", { read: ViewContainerRef }) childContainer: ViewContainerRef;
  instanciaInterna: any;
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<PopupDialogComponent>,private componentFactoryResolver: ComponentFactoryResolver){
    this.title = data.title;
    this.icon = data.icon;

    if(data.cancelTitle)
      this.cancelTitle = data.cancelTitle

    if(data.useConfirm != undefined)
      this.useConfirm = data.useConfirm
  }

  ngOnInit(): void {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.data.formulario);
    // this.childContainer.clear();
    const componentRef = this.childContainer.createComponent(componentFactory);
    this.instanciaInterna = componentRef.instance;
    if(this.instanciaInterna.setData){
      this.instanciaInterna.setData(this.data);
    }
  }

  fechar = () => {
    this.dialogRef.close({salvo:false});
  }
  
  aoSalvar = (obj) => {
    this.dialogRef.close({salvo:true, obj:obj});
  }
}
